import { CardContent } from "@heroui/react";
import type { Campaign } from "../model/types";

export interface CampaignCardStatsProps {
  campaign: Campaign;
}

export const CampaignCardStats = ({ campaign }: CampaignCardStatsProps) => {
  const stats = campaign.weekly_stats;

  return (
    <CardContent className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
      {/* 1. Бюджет в неделю */}
      <div>
        <div className="text-xs text-neutral-400">Бюджет в неделю</div>
        <div className="font-semibold">
          {stats?.budget
            ? `${stats.budget.toLocaleString("ru-RU")} ₽`
            : campaign.weekly_budget_amount
              ? `${campaign.weekly_budget_amount.toLocaleString("ru-RU")} ₽`
              : campaign.budget || "Не задан"}
        </div>
      </div>

      {/* 2. Расход за 7 дней */}
      <div>
        <div className="text-xs text-neutral-400">Расход за 7 дн.</div>
        <div className="font-semibold">
          {stats
            ? `${stats.cost.toLocaleString("ru-RU")} ₽`
            : campaign.spent || "0 ₽"}
        </div>
        {stats?.avg_daily_cost != null && (
          <span className="text-[11px] text-neutral-400 block truncate">
            ~{stats.avg_daily_cost.toLocaleString("ru-RU")} ₽/день
          </span>
        )}
      </div>

      {/* 3. Клики за 7 дней */}
      <div>
        <div className="text-xs text-neutral-400">Клики за 7 дн.</div>
        <div className="font-semibold">
          {stats ? stats.clicks.toLocaleString("ru-RU") : campaign.clicks || "0"}
        </div>
        {stats?.avg_daily_clicks != null && (
          <span className="text-[11px] text-neutral-400 block truncate">
            ~{stats.avg_daily_clicks} кликов/день
          </span>
        )}
      </div>

      {/* 4. CTR */}
      <div>
        <div className="text-xs text-neutral-400">CTR</div>
        <div className="font-semibold text-emerald-600">
          {stats ? `${stats.ctr}%` : campaign.ctr || "0%"}
        </div>
        {stats?.impressions != null && (
          <span className="text-[11px] text-neutral-400 block truncate">
            {stats.impressions.toLocaleString("ru-RU")} показов
          </span>
        )}
      </div>
    </CardContent>
  );
};
